<div class="w-75">
  <h1 class="title">Sök specifikt smittämne</h1>
  <p class="brodtext-medium-14">
    Nedan kan data sökas i Svebars databas. Här söker man på ett specifikt smittämne (art) för att få fullständig <br>
    sammanställd antibiotikaresistensdata. En större mängd data kan sammanställas desto mer frågan specificeras <br>
    (exempelvis genom att välja analys). Endast ett smittämne kan väljas i denna sökfunktion. En tabell visar antal <br>
    testade isolat för respektive antibiotika samt procent resistens. När sökningen är genomförd kan man välja att titta <br>
    på sammanställd antibiotikaresistens i en tabell eller att få upp raddata för sökningen genom att välja de olika <br>
    alternativen nedan. Båda sammanställningarna går att spara ner som csv.filer för vidare bearbetning.
  </p>
  <app-search-form [searchType]="searchType"></app-search-form>
</div>
